import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-portfolio-two-column',
  templateUrl: './portfolio-two-column.component.html',
  styleUrl: './portfolio-two-column.component.css'
})
export class PortfolioTwoColumnComponent {
  isTransparent = true;
  isMenuOpen = false;
  activeDropdown: number | null = null;

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  toggleDropdown(index: number): void {
    this.activeDropdown = this.activeDropdown === index ? null : index;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    this.activeDropdown = null;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.nav-item') && !target.closest('.header-toggle')) {
      this.activeDropdown = null;
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isTransparent = offset < 100;
  }

  //Header End

  //Works
  portfolioWorks =[
    {
      img:'assets/images/portfolio/gallery-11.jpg',
      title:'Digital Food',
      category:'Branding',
      link: '/portfolio-detail'
    },
    {
      img:'assets/images/portfolio/gallery-12.jpg',
      title:'Poster',
      category:'Branding',
      link: '/portfolio-detail'
    },
    {
      img:'assets/images/portfolio/gallery-13.jpg',
      title:'Blue Berry',
      category:'Branding',
      link: '/portfolio-detail'
    },
    {
      img:'assets/images/portfolio/gallery-14.jpg',
      title:'Death Proof',
      category:'UI/UX Design',
      link: '/portfolio-detail'
    },
    {
      img:'assets/images/portfolio/gallery-15.jpg',
      title:'Ten Branding',
      category:'Branding, UX Design',
      link: '/portfolio-detail'
    },
    {
      img:'assets/images/portfolio/gallery-16.jpg',
      title:'Old Camera',
      category:'UI/UX Design',
      link: '/portfolio-detail'
    }
  ];
  
}
